import { Box, Flex, Grid, GridItem, Image, Text } from '@chakra-ui/react'
import React from 'react'

const ProfileFooter = () => {
  return (
    <Box w='100%' display='flex' justifyContent='center' bgColor='#315b84'>
      <Box maxW='1300px' w='83%' padding='60px 12px 35px'>
        <Grid templateColumns={'repeat(2, 1fr)'} gap={10}>
          <GridItem colSpan={{ base: 2, lg: 1 }}>
            <Box display='flex' gap='20px' width='100%'>
              <Image
                src='https://marketplace.redswan.io/img/redswanicon.png'
                height='71px'
                width='60px'
              />
              <Text fontSize='14px' color='white'>
                Asset Tokenization CRE is a digital securities platform for compliant issuance of real estate digital security shares and provides liquidity for investors - powered by blockchain technology.
              </Text>
            </Box>
          </GridItem>
          <GridItem colSpan={{ base: 2, lg: 1 }} fontSize='14px' color='white'>
            <Flex justifyContent={{ base: 'center', lg: 'flex-end' }}>
              <Box textAlign={{ base: 'center', lg: 'right' }}>
                <Text>
                  <a>Privacy Policy</a> & <a>Terms of Services</a>
                </Text>
                <Text>
                  Suite 313, 833 Bourbon Court, Mountain View, 94041 CA
                </Text>
                <Text>
                  +1 310 909 7947
                </Text>
                <Text>
                  info@scytalelabs.com
                </Text>
              </Box>
            </Flex>
          </GridItem>
        </Grid>
        <Box marginTop='50px'>
          <Text fontSize='12px' color='#FFFFFF'>
            Digital assets issued by Asset Tokenization Real Estate Fund, LLC, a registered investment advisor of Asset Tokenization PC, Inc. The material on this communication is for informational purposes only. This is not an offering memorandum or prospectus and should not be treated as such. Investments involve risk, including principal loss, and are not guaranteed. Returns shown are targeted and subject to change. The opportunity presented here is undertaken pursuant to Rule 506(c) of Regulation D under the Securities Act and may be made only by Accredited Investors in the US and investors outside of the United States under Regulation S. Be sure to consult with a qualified financial advisor.
          </Text>
        </Box>
      </Box>
    </Box>
  )
}

export default ProfileFooter